// Story 10.1 — UI store: preferencias persistidas (sidebar, tema).
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'dark'; // future: 'light' | 'system'
export type Density = 'compact' | 'comfortable';

export interface UIState {
  sidebarCollapsed: boolean;
  theme: Theme;
  density: Density;
  toggleSidebar(): void;
  setSidebar(collapsed: boolean): void;
  setDensity(d: Density): void;
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      theme: 'dark',
      density: 'comfortable',
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSidebar: (collapsed) => set({ sidebarCollapsed: collapsed }),
      setDensity: (density) => set({ density }),
    }),
    {
      name: 'revel-ui',
      // Story 10.1: solo persistir el subset que sí queremos rehidratar.
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        theme: state.theme,
        density: state.density,
      }),
    },
  ),
);

/**
 * Menú lateral abierto en pantallas angostas. Estado efímero: va aparte para
 * no pasar por `persist` (cada apertura escribiría en localStorage).
 */
export const useMobileNavStore = create<{ open: boolean; setOpen(open: boolean): void }>()(
  (set) => ({
    open: false,
    setOpen: (open) => set({ open }),
  }),
);
